const redact = (url) => {
  if (drupalSettings.gtag_redacted !== undefined) {
    const allowList = JSON.parse(drupalSettings.gtag_redacted);
    const queryStarts = url.indexOf("?");

    if (queryStarts === -1 || queryStarts === url.length - 1) {
      return url;
    }

    let parameters = url.substring(queryStarts + 1).split("&");
    parameters = parameters.map(function (keyPair) {
      if (keyPair.length === 0) {
        return keyPair;
      }

      const key = keyPair.split("=")[0];
      const value = keyPair.split("=")[1];
      const pass = allowList.some(function (allowedPair) {
        if (
          new RegExp(
            allowedPair.keyPattern.replace("/^\\/?(.*)\\/$/gm;", "")
          ).test(key) &&
          new RegExp(
            allowedPair.valuePattern.replace("/^\\/?(.*)\\/$/gm;", "")
          ).test(value)
        ) {
          return true;
        }

        return false;
      });

      if (pass === true) {
        return keyPair;
      }

      return ["redactedParameter_".concat(key)];
    });
    return url.substring(0, queryStarts + 1) + parameters.join("&");
  }

  return url;
};

export default redact;
